<template>
  <div class="expList">
    <div class="head">
      <p><span>成为了第</span><span class="number" style="text-shadow:3px 3px 3px #80C7D0">&nbsp;{{explistData.orderNumber}}&nbsp;</span><span>名体验官</span></p>
      <img width="100%" :src='require("../../assets/images/download/head.jpg")' />
    </div>
    <div class="gift">
      <div class="txt">
        <h2>300元专属乘车体验礼包您已领取过</h2>
        <p><span>300</span>元</p>
      </div>
      <div style="min-height: 130px;background: #fff;">
        <img width="100%" :src='require("../../assets/images/download/gift.png")' />
      </div>
    </div>
    <div class="main">
      <a href="javascript:;" class="downApp" @click="gotoDownApp">下载享道出行APP</a>
      <div class="owner">
       <span class="gt">&gt;&gt;&gt;</span>让品质安全出行触手可及<span class="gt">&lt;&lt;&lt;</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getDay } from '@/data/api/experince'
import Cookie from '@/common/utils/Cookie.js'
import UpdateLogData from '@/data/api/common/Log/UpdateLogData.js'
export default {
  name: 'ExperienceExplistPage',
  data () {
    return {
      show: true,
      explistData: {
        orderNumber: '',
        form: {

        }
      }
    }
  },
  mounted () {
    this.getDays()
    UpdateLogData({path: this.$route.path, action: 'finishLoad', query: this.$route.query, hasRedPacket: true})
  },
  methods: {
    getDays: function () {
      if (!Cookie.get('Admin-Token')) {
        //  获取不到token => 未登录
        this.$mint.MessageBox.alert('请先登录！').then(_ => {
          window.location.href = window.location.pathname + '#/experience' + `?channel=${this.$route.query.channel}`
          document.title = '首席体验官招募令'
        })
        return
      }
      this.$mint.Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      })
      getDay(this.explistData.form).then((response) => {
        this.explistData.orderNumber = response.rank
      }).catch(() => {}).finally(() => {
        this.$mint.Indicator.close()
      })
    },
    gotoDownApp: function () {
      window.location.href = window.location.pathname + '#/download' + `?channel=${this.$route.query.channel}`
      document.title = '下载'
    }
  }

}
</script>

<style scoped lang="stylus">
.expList {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width:100%
  background: linear-gradient(to bottom, #e85060, #ed3345);
  img{
    display: block;
  }
  .head{
    position: relative;
    p{
      position: absolute;
      top: 8.5rem;
      font-weight :bold;
      width: 100%;
      text-align: center;
      font-size: 1.5rem;
      color: #fff;
      span:nth-child(1){
        text-shadow :0px 1px 1px grey
      }
       span:nth-child(3){
        text-shadow :0px 1px 1px grey
      }
      span.number{
        color: #f6e097;
        font-size: 2.5rem;
        vertical-align:sub;
      }
    }
  }
  .gift{
    position: relative;
    margin-top: -2.8125rem;
    z-index: 10;
    .txt{
      position: absolute;
      top: 0;
      width: 100%;
      padding-top: 1.2rem;
      text-align: center;
      h2{
        height: 2rem;
        line-height 2rem;
        font-size: 1rem;
        color: #666;
        font-weight: normal;
      }
      p{

        color: #F25E53;
        span{
          font-size: 3.125rem;
        }
      }
    }
  }
  .main{
    .downApp{
      display: block;
      width: 100%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #333;
      font-weight: bold;
      font-size: 1rem;
      border-radius: 5px;
      margin-bottom: 15px;
      background: linear-gradient(70deg, #F6E097, #F8EFD2);
    }
    .owner{
      color:#fff;
      text-align center;
      margin-top:4.5rem;
      letter-spacing:2px;
      font-size:14px;
      padding-bottom:3rem;
      .gt{
        color:#ddd;
      }
    }
    li{
      background-color: #fff;
      border-radius: 5px;
      padding: 0 15px;
      margin-bottom: 15px;
      .m1{
        padding: 15px 0 10px;
        border-bottom: 1px dotted #ddd;
        overflow: hidden;
        .mLeft{
          float: left;
          h2{
            color: #333;
            font-size: 1rem;
          }
          p{
            color: #999;
            font-size: 0.75rem;
          }
        }
        .price{
          float: right;
          color: #00b2a9;
          font-family: Arial, Helvetica, sans-serif;
          span{
            font-size: 2rem;
          }
        }
      }
      .m2{
        padding: 10px 0;
        font-size: 0.7rem;
        color: #aaa;
      }
    }
    bottom: 0;
    padding: 15px;
    background: linear-gradient(to bottom, #e85060, #ed3345);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Experience/oldExplist.vue